import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

//import img

//import components
import StrucutreListItemSingle from './StrucutreListItemSingle.js';
import StrucutreListItemContent from './StrucutreListItemContent.js';

class StrucutreListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };
    };

    componentDidMount() {
       const {setOpened} = this.props;

       if (setOpened) {
         this.setState({isOpened: true});
       }
    };

    toggleOpened = () => {
        const {getFieldChildren, id, children, expansible, setStructureListHeight} = this.props;

        if (!this.state.isOpened && !children && expansible) {
            getFieldChildren(id);
        }
        this.setState({isOpened: !this.state.isOpened});
        setStructureListHeight();
    };

    render() {
        const {isOpened} = this.state;
        const { label, children, getFieldChildren, id, setStructureListHeight, shortDescription, recordsNumber, contact } = this.props;

        return (
            <li className="structure__list-item">
                <div className="structure__list-item__container">
                    <button className={isOpened ? "structure__hide" : "structure__open"}
                            onClick={() => this.toggleOpened()}>
                        {!isOpened && <span>+</span>}
                        {isOpened && <span>-</span>}
                    </button>
                    <StrucutreListItemContent id={id} label={label} shortDescription={shortDescription} recordsNumber={recordsNumber}
                        contact={contact} setStructureListHeight={setStructureListHeight}/>
                </div>
                {isOpened && children &&
                    <ul className="structure__inner-list">
                        {children.map((child, index) => child.expansible || (child.children && child.children.length > 0) ?
                            <StrucutreListItem key={index} {...child}
                                getFieldChildren={getFieldChildren}
                                setStructureListHeight={setStructureListHeight}/>
                            : <StrucutreListItemSingle key={index} {...child} setStructureListHeight={setStructureListHeight}/>)}
                    </ul>}
            </li>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(StrucutreListItem));



// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItem.js